import {
  __,
  always,
  applySpec,
  chain,
  converge,
  curry,
  filter,
  identity,
  join,
  map,
  pipe,
  unapply,
} from "ramda";
import { of } from "most";
import { debounce, recoverWith } from "common/mostCurried";
import { select, selectArray, withState } from "redux-most";
import * as applicationActions from "application/applicationActions";
import * as submissionActions from "submission/submissionActions";
import {
  fetchFromLocalStorage,
  saveToLocalStorage,
  removeObjectFromLocalStorage,
} from "common/localStorageHelpers";
import {
  doesStepHaveErrors,
  getNextIncompleteStep,
  getOrganizationAlias,
  getProjectKey,
} from "common/selectors";
import * as steps from "./steps";

const createStepKey = curry((step, state) =>
  pipe(
    converge(unapply(identity), [
      getProjectKey,
      getOrganizationAlias,
      always(step),
    ]),
    filter(identity),
    join("-")
  )(state)
);

const removeStepFromLocalStorage = curry((step, state) =>
  removeObjectFromLocalStorage(createStepKey(step, state))
);

export const createAcknowledgeSubmissionEpic = (step) => (action$, state$) =>
  pipe(
    select(submissionActions.ACKNOWLEDGE_SUBMISSION_COMPLETE),
    withState(state$),
    chain(([state, action]) =>
      pipe(
        removeStepFromLocalStorage(step),
        map(submissionActions.localStorageSynced)
      )(state)
    )
  )(action$);

export const createSyncLocalStorageEpic =
  (actionTypes, spec, actionCreator, step) => (action$, state$) =>
    pipe(
      selectArray(actionTypes),
      debounce(200),
      withState(state$),
      chain(([state, action]) =>
        pipe(
          createStepKey(step),
          saveToLocalStorage(__, applySpec(spec)(state)),
          map(actionCreator),
          recoverWith(pipe(applicationActions.appError, of))
        )(state)
      )
    )(action$);

export const createLoadLocalStorageEpic =
  (step, actionCreator) => (action$, state$) =>
    pipe(
      select(submissionActions.LOCAL_STORAGE_LOADED),
      withState(state$),
      chain(([state, action]) =>
        pipe(
          createStepKey(step),
          fetchFromLocalStorage,
          map(actionCreator),
          recoverWith(pipe(applicationActions.appError, of))
        )(state)
      )
    )(action$);

export const createCompleteStepEpic =
  (actionType, step) => (action$, state$) => {
    return pipe(
      select(actionType),
      withState(state$),
      map(([state, action]) =>
        doesStepHaveErrors(step, state)
          ? submissionActions.showValidationErrorsDialog(true)
          : submissionActions.setActiveStep(
              getNextIncompleteStep(state) || steps.TERMS
            )
      )
    )(action$);
  };
